module.exports = __webpack_public_path__ + "img/undraw_online_test_gba7.d45e8974.svg";